import { createUseStyles } from "react-jss";

export default createUseStyles({
    loading: {
        color: "#919191",
        textAlign: "center",
        padding: [[12, 0]],
        lineHeight: "20px",
        fontSize: "11px",
        fontWeight: 700,
    },
});
